import styled from 'styled-components';
import { SelectInput as Select } from '@latitude/select-input';
import { Box } from '@latitude/box';
import { Link } from '@latitude/link';
import { BREAKPOINT, COLOR } from '@latitude/core/utils/constants';

/* EstimateRateWidgetSection.tsx */
export const EstimateRateWidgetSectionWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

/* EstimateRateWidget.tsx */
export const MainContent = styled(Box)`
  background-color: ${COLOR.BLUE_BABY};
  padding: 24px 24px 8px;
  border: 1px solid ${COLOR.GREY4};
  border-bottom: 0px;
`;

export const MainContentKiwibank = styled(Box)`
  background-color: ${COLOR.WHITE};
  padding: 24px 24px 8px;
  border: 1px solid ${COLOR.GREY4};
  border-bottom: 0px;
`;

export const FormFields = styled(Box)`
  max-width: 300px;
  margin: auto;
  @media (min-width: ${BREAKPOINT.XL}) {
    max-width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;

export const LoanPurposeField = styled.div`
  @media (min-width: ${BREAKPOINT.XL}) {
    flex: 0 1 calc(40% - 16px);
  }
`;

export const BorrowAmountField = styled.div`
  @media (min-width: ${BREAKPOINT.XL}) {
    flex: 0 1 calc(30% - 8px);
  }
`;

export const BorrowAmountFieldKb = styled.div`
  @media (min-width: ${BREAKPOINT.XL}) {
    flex: 0 1 calc(45% - 8px);
  }
`;

export const RepaymentPeriodField = styled.div`
  @media (min-width: ${BREAKPOINT.XL}) {
    flex: 0 1 calc(30% - 8px);
  }
`;

export const RepaymentPeriodFieldKb = styled.div`
  border-color: #000 !important;
  color: #000 !impotrtant;
  @media (min-width: ${BREAKPOINT.XL}) {
    flex: 0 1 calc(45% - 8px);
  }
`;

export const StyledSelect = styled(Select)`
  padding: 5px 32px 5px 0px;
`;

export const StyledSelectKb = styled(Select)`
  padding: 5px 32px 5px 0px;
  color: #000 !important;
  border-color: #000 !important;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzJweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+MThCQTQ4ODgtREFFQy00NTRBLTlCQ0UtNzQwNUE0Q0FGODI5QDF4PC90aXRsZT4KICAgIDxnIGlkPSJVSS0tLUFVLUN1c3RvbWVyIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTEZTLU0tLS1XaWRnZXQtRGV0YWlsZWQtVUktLS1Tb2Z0cXVvdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTkyMC4wMDAwMDAsIC0xMzA1LjAwMDAwMCkiIGZpbGw9IiM0MjQ4NEQiPgogICAgICAgICAgICA8ZyBpZD0iRGVza3RvcC0vLVF1b3RlLS8tQ2hlY2stUmF0ZS1XaWRnZXQtLy1Cb2R5LVNoYWRvdy1Cb3gtQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE2NTcuMDAwMDAwLCAxMTMyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IkZpZWxkcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuMDAwMDAwLCAxNDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkZpZWxkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJTaGFyZWQtQ29yZS1DaGV2cm9uRG93biIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM5LjAwMDAwMCwgNi4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMC43MDcxMDY4LDEyLjI5Mjg5MzIgQzEwLjMxNjU4MjUsMTEuOTAyMzY4OSA5LjY4MzQxNzUxLDExLjkwMjM2ODkgOS4yOTI4OTMyMiwxMi4yOTI4OTMyIEM4LjkwMjM2ODkzLDEyLjY4MzQxNzUgOC45MDIzNjg5MywxMy4zMTY1ODI1IDkuMjkyODkzMjIsMTMuNzA3MTA2OCBMMTUuMjkyODkzMiwxOS43MDcxMDY4IEMxNS42ODM0MTc1LDIwLjA5NzYzMTEgMTYuMzE2NTgyNSwyMC4wOTc2MzExIDE2LjcwNzEwNjgsMTkuNzA3MTA2OCBMMjIuNzA3MTA2OCwxMy43MDcxMDY4IEMyMy4wOTc2MzExLDEzLjMxNjU4MjUgMjMuMDk3NjMxMSwxMi42ODM0MTc1IDIyLjcwNzEwNjgsMTIuMjkyODkzMiBDMjIuMzE2NTgyNSwxMS45MDIzNjg5IDIxLjY4MzQxNzUsMTEuOTAyMzY4OSAyMS4yOTI4OTMyLDEyLjI5Mjg5MzIgTDE2LDE3LjU4NTc4NjQgTDEwLjcwNzEwNjgsMTIuMjkyODkzMiBaIiBpZD0iUGF0aC0zIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==');
`;

export const GetStartedButton = styled(Link)`
  width: 150px;
  margin-bottom: 16px;
`;

export const CheckEligibilityButton = styled(Link)`
  width: 180px;
  margin-bottom: 16px;
`;

export const Footer = styled(Box)`
  background-color: ${COLOR.BLUE_SKY};
  border: 1px solid ${COLOR.GREY4};
  padding: 8px 24px;
  border-top: 0px;
`;

export const FooterKiwibank = styled(Box)`
  background-color: ${COLOR.GREY4};
  border: 1px solid ${COLOR.GREY4};
  padding: 8px 24px;
  border-top: 0px;
`;
